import { HelpArticleDirectory } from "@/@types/help/Articles";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import classes from "@/styles/help/directory-section.module.css";
interface Props {
  content: HelpArticleDirectory;
  color?: string;
}
const DirectorySection = ({ content: { about, subPages }, color }: Props) => {
  return (
    <div>
      <h4>About</h4>
      <div>{about ?? "No description available."}</div>
      <div>
        <Row>
          {subPages.map(({ name, path, imageUrl }, i) => {
            const isBlocked = path === "#";

            return (
              <Col className="p-3" xs={12} lg={4} key={i}>
                <Link
                  key={i}
                  href={path}
                  className={`${isBlocked ? "blocked" : ""}`}
                >
                  <Card className={classes.card}>
                    <CardBody>
                      <div className={`${classes.cardImgWrapper}`}>
                        <Image
                          src={imageUrl}
                          alt={name}
                          className="img-fluid"
                          height={150}
                          width={200}
                        />
                      </div>
                      <div className="details">
                        <h6 className="text-secondary text-center">{name}</h6>
                      </div>
                    </CardBody>
                  </Card>
                </Link>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default DirectorySection;
